import * as React from 'react';
import { Component, Fragment } from 'react';
import { action, observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Chevron from './Chevron';
import Checkbox from './Checkbox';
import DownloadControls from './DownloadControls';
import ClickLayer from './ClickLayer';
import get from 'lodash/get';

const DropDownWrapper = styled<any, any>('div')`
    ${propStyles};
    position: relative;
`;

DropDownWrapper.defaultProps = {
    display: "inline-flex"
};

const DropDownButton = styled<any, any>('button')`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

DropDownButton.defaultProps = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "inherit",
    fontFamily: "inherit",
    fontWeight: "inherit",
    textAlign: "right",
    bgColor: "transparent",
    borderStyle: "none"
};

const DocumentDropdown = styled<any, any>('div')`
    ${propStyles};
    top: 100%;
    right: 0;
`;

DocumentDropdown.defaultProps = {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    minWidth: "160px",
    maxWidth: "400px",
    maxHeight: "240px",
    overflowY: "auto",
    bgColor: "white",
    boxShadow: "sm",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "solid",
    borderRadius: "sm",
    zIndex: "dropdown"
};

const DropdownItem = styled<any, any>('div')`
    ${propStyles};
`;

DropdownItem.defaultProps = {
    display: "flex",
    alignItems: "center",
    flex: "0 0 auto",
    paddingX: "md",
    paddingY: "sm",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "none none solid none",
    hover: {
        bgColor: "gray100"
    }
};

const checkboxStyleProps = {
    CheckboxChecked: {
        height: "1.4em",
        width: "1.4em",
        marginX: "xs"
    },
    CheckboxUnchecked: {
        height: "1.4em",
        width: "1.4em",
        marginX: "xs"
    }
};

@inject('dataStore')
@observer
class DocumentDropDown extends Component<any, any> {
    @observable open = false;

    @action
    toggleDropdown = () => {
        this.open = !this.open;
    }

    render() {
        const { theme, dataStore, documents, children, showCheckbox, documentSelected, toggleDownload } = this.props;
        return (
            <DropDownWrapper>
                <DropDownButton 
                    onClick={e => { e.stopPropagation(); this.toggleDropdown(); }}
                >
                    {children}
                    <Chevron 
                        direction={this.open ? "up" : "down"} 
                        iconSize="1.4em"
                    />
                </DropDownButton>
                {
                    this.open && (
                        <Fragment>
                            <ClickLayer onClick={e => { e.stopPropagation(); this.toggleDropdown(); }} />
                            <DocumentDropdown
                                {...theme.DocumentDropdown}
                            >
                                {
                                    documents.map((document, index) => {
                                        const isSelected = documentSelected(document.clientCode);

                                        return (
                                            <DropdownItem
                                                key={document.clientCode}
                                                {...theme.DocumentDropdownItem}
                                            >
                                                {
                                                    showCheckbox && (
                                                        <Checkbox
                                                            checked={isSelected}
                                                            onChange={() => toggleDownload(document.clientCode)}
                                                            theme={{
                                                                ...theme,
                                                                ...checkboxStyleProps
                                                            }}
                                                        />
                                                    )
                                                }
                                                <DownloadControls
                                                    onClick={e => { e.stopPropagation(); dataStore.downloadDocuments([document.clientCode]); }}
                                                    label={
                                                        get(
                                                            this.props.dataStore.config.cultureAliases, 
                                                            document.cultureCode, 
                                                            document.cultureCode
                                                        )
                                                    }
                                                    count={documents.length}
                                                    showCount={false}
                                                    flex="1 0 0%"
                                                    theme={{
                                                        ...theme,
                                                        ...{
                                                            DownloadButton: {
                                                                flex: "1 0 0%",
                                                                justifyContent: "space-between"
                                                            }
                                                        }
                                                    }}
                                                />
                                            </DropdownItem>
                                        );
                                    })
                                }
                            </DocumentDropdown>
                        </Fragment>
                    )
                }
            </DropDownWrapper>
        );
    }
}

export default withTheme(DocumentDropDown) as any;


// WEBPACK FOOTER //
// ./src/Components/DocumentDropDown.tsx